import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { CommonModule } from '@angular/common';
import { AuthorizeFieldViewDirective } from '../../../../shared/authorization/authorizeFieldView.directive';
import { PROVIDER_TYPES, STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { Program } from '../../../../interfaces/user.interface';
import { UserService } from '../../../../services/user.service';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { ButtonComponent } from '@ppl/ui';

@Component({
  selector: 'ppl-lead-payment-method',
  standalone: true,
  imports: [NgZorroModule, CommonModule, AuthorizeFieldViewDirective, ButtonComponent],
  templateUrl: './lead-payment-method.component.html',
  styleUrl: './lead-payment-method.component.css'
})
export class LeadPaymentMethodComponent extends BaseComponent implements OnInit {
 

  @Input() pageId = '';
  @Input() tabId = '';
  @Input() entry = '';
  @Input() program !: Program;
  canUnmaskBankDetails: boolean = false;
  selectedIdentifier: string = '';
  paymentInfo?: any;
  
  constructor(private userService: UserService, private leadDetailsService: LeadDetailsService,
    private authUtility: AuthorizationUtility,
  ){
    super();
  }

  ngOnInit(): void {
    this.loadPaymentInfo();
    this.canUnmaskBankDetails = this.authUtility.isSectionVisible(this.pageId, this.tabId, 'PaymentMethodUnmask');
  }

  loadPaymentInfo() {
    const id = this.userService.getSelectedLead() ?? '';
    this.selectedIdentifier = id.toString();
    this.leadDetailsService.getPaymentInfo(this.program?.program_code, id).subscribe((data: any) => {
      this.paymentInfo = data?.responsedata;
    });
  }

  unmaskIdentifier(identifierType: string){
    const payload =  {
            "identifier": this.selectedIdentifier,
            "source": 'PPL@Home',
            "identifierType": identifierType,
            "userType": 'provider',
            "userCategory": 'bankinfo'
           };
    
    this.leadDetailsService.unmaskIdentifier(this.program?.program_code, payload).subscribe(data => {
            if (identifierType === 'ROUTING'){
              this.paymentInfo.routingNumber = data.responsedata;
            }
            else if (identifierType === 'ACCOUNT'){
              this.paymentInfo.accountNumber = data.responsedata;
            }
    });
  }
}
